export default __webpack_public_path__ + "static/media/960px-240px-Scrub-Sky-Turbines-Hero-Large.jpg.e8cd8237.webp";